var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pickl && _vm.pickl.id
    ? _c(
        "div",
        {
          staticClass: "green-border-box white-bg text-center pickl",
          class: { disabled: _vm.disabled }
        },
        [
          _c("div", { staticClass: "top-part" }, [
            _c(
              "div",
              { staticClass: "posRel" },
              [
                _c("div", { staticClass: "grey-logo-circle company-logo" }, [
                  _c("img", {
                    staticClass: "img-in-circle",
                    attrs: {
                      src: _vm.pickl.store_location.store.image + "?w=150&q=50"
                    },
                    on: {
                      error: function($event) {
                        _vm.pickl.store_location.store.image =
                          "/img/default_store_image.png"
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "grey-logo-circle product-logo" }, [
                  _c("img", {
                    staticClass: "img-in-circle",
                    attrs: { src: _vm.pickl.brand.logo + "?w=150&q=50" },
                    on: {
                      error: function($event) {
                        _vm.pickl.brand.logo = "/img/pickl-logo.png"
                      }
                    }
                  })
                ]),
                _c(
                  "h4",
                  {
                    directives: [
                      {
                        name: "autosize",
                        rawName: "v-autosize",
                        value: 15,
                        expression: "15"
                      }
                    ],
                    attrs: { title: _vm.pickl.store_location.store.name }
                  },
                  [_vm._v(_vm._s(_vm.pickl.store_location.store.name))]
                ),
                _c(
                  "h5",
                  {
                    directives: [
                      {
                        name: "autosize",
                        rawName: "v-autosize",
                        value: 12,
                        expression: "12"
                      }
                    ],
                    attrs: { title: _vm.pickl.brand.name }
                  },
                  [_vm._v(_vm._s(_vm.pickl.brand.name))]
                ),
                _c(
                  "h5",
                  {
                    directives: [
                      {
                        name: "autosize",
                        rawName: "v-autosize",
                        value: 12,
                        expression: "12"
                      }
                    ],
                    attrs: { title: _vm.pickl.reimbursement_credits }
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        "$" +
                          _vm._s(_vm.pickl.credits) +
                          " Award + $" +
                          _vm._s(_vm.pickl.reimbursement_credits) +
                          " Deal"
                      )
                    ])
                  ]
                ),
                _vm.pickl.pickl_campaign
                  ? _c(
                      "h5",
                      {
                        directives: [
                          {
                            name: "autosize",
                            rawName: "v-autosize",
                            value: 12,
                            expression: "12"
                          }
                        ],
                        attrs: { title: _vm.pickl.pickl_campaign.name }
                      },
                      [
                        _vm._v(
                          "Campaign: " + _vm._s(_vm.pickl.pickl_campaign.name)
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.pickl.multiple_responses == 1 && _vm.isSadminOrStaff()
                  ? _c("h5", { attrs: { alt: "dfd" } }, [
                      _c("strong", [
                        _vm._v(
                          "\n              L: " +
                            _vm._s(
                              _vm.pickl.response_counter -
                                _vm.pickl.accepted_user_pickls_count -
                                _vm.pickl.completed_user_pickls_count -
                                _vm.pickl.approved_user_pickls_count
                            ) +
                            "\n              | H: " +
                            _vm._s(_vm.pickl.accepted_user_pickls_count) +
                            "\n              | C: " +
                            _vm._s(_vm.pickl.completed_user_pickls_count) +
                            "\n              | A: " +
                            _vm._s(_vm.pickl.approved_user_pickls_count) +
                            "\n              | T: " +
                            _vm._s(_vm.pickl.response_counter) +
                            "\n            "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.isSadminOrStaff()
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          target: "_blank",
                          to:
                            "/" +
                            _vm.userUrl +
                            "/picklrs?lat=" +
                            _vm.pickl.store_location.latitude +
                            "&lng=" +
                            _vm.pickl.store_location.longitude
                        }
                      },
                      [_vm._v("View Nearby Users")]
                    )
                  : _vm._e(),
                _vm.isSadminOrStaff() && _vm.pickl.user_pickl
                  ? _c(
                      "label",
                      {
                        staticStyle: {
                          display: "block",
                          width: "100%",
                          "text-align": "center"
                        }
                      },
                      [
                        _vm._v(
                          "Completed By: " +
                            _vm._s(_vm.pickl.user_pickl.user.name) +
                            " | " +
                            _vm._s(
                              _vm._f("phone")(
                                _vm.pickl.user_pickl.user.mobile_number
                              )
                            )
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "middle-part" }, [
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "address",
                  attrs: { title: _vm.pickl.store_location.address }
                },
                [_vm._v(_vm._s(_vm.pickl.store_location.address))]
              ),
              _vm.pickl.launch_type == "retailer-any-location"
                ? _c("div", {
                    staticClass: "address",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.getPicklTargetedStatesOrCities(_vm.pickl)
                      )
                    }
                  })
                : _vm._e(),
              _vm.pickl.processing_time
                ? _c("div", { staticClass: "address" }, [
                    _vm._v(
                      "Processing Time: " + _vm._s(_vm.pickl.processing_time)
                    )
                  ])
                : _vm._e()
            ]),
            _vm.pickl.rating
              ? _c(
                  "div",
                  { staticClass: "rating" },
                  _vm._l(_vm.pickl.rating, function(n) {
                    return _c("img", {
                      key: n,
                      attrs: { src: "/img/Alerts/picklerating_icon.png" }
                    })
                  }),
                  0
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "status", style: { color: _vm.statusColor } },
              [
                _vm._v(
                  "Launched: " +
                    _vm._s(_vm.pickl.start_date) +
                    " @ " +
                    _vm._s(_vm.pickl.start_time)
                )
              ]
            ),
            _vm.pickl.status == "PENDING" || _vm.pickl.status == "ACCEPTED"
              ? _c(
                  "div",
                  { staticClass: "status", style: { color: _vm.statusColor } },
                  [
                    _vm._v(
                      "Expiring In: " + _vm._s(_vm.pickl.expiring_in) + " Days"
                    )
                  ]
                )
              : _vm._e(),
            _vm.pickl.status == "EXPIRED"
              ? _c(
                  "div",
                  { staticClass: "status", style: { color: _vm.statusColor } },
                  [_vm._v("Expired")]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "status", style: { color: _vm.statusColor } },
              [_vm._v(_vm._s(_vm.statusText))]
            ),
            _vm.checkOpenForDiscussion
              ? _c("img", {
                  staticClass: "loud-phone",
                  attrs: {
                    src: "/img/megaphone.png",
                    title: "ALERT: Review internal notes"
                  }
                })
              : _vm._e()
          ]),
          _c("div", { staticClass: "bottom-part" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-6 pickl-date" }, [
              _c("img", { attrs: { src: "/img/Picklr/date_icon.png" } }),
              _vm._v(" " + _vm._s(_vm.pickl.date) + "\n        ")
            ]),
            _c("div", { staticClass: "col-xs-12 col-sm-6 pickl-date" }, [
              _c("img", { attrs: { src: "/img/Picklr/time_icon.png" } }),
              _vm._v(" " + _vm._s(_vm.pickl.time) + "\n            "),
              _vm.pickl.extend_counter > 0
                ? _c(
                    "span",
                    {
                      staticClass: "pull-right",
                      attrs: {
                        tip: "",
                        title: "Extend counter: " + _vm.pickl.extend_counter
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "mr3",
                        staticStyle: { "margin-top": "3px" },
                        attrs: {
                          "data-v-4cc8d1bb": "",
                          src: "/img/Alerts/timeGreen_icon.png"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            background: "rgb(18, 219, 109)",
                            "border-radius": "150px",
                            color: "white",
                            "text-align": "center",
                            padding: "0 6px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.pickl.extend_counter))]
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "clearfix" })
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }